/*!
 * Copyright © 2019-2023. Verizon Connect Ireland Limited. All rights reserved.
 */

export const FEATURE_TOGGLES = {
  ClusteringByDefault: 'LiveMap_ClusteringByDefault',
  OverrideTowingPoc: 'LiveMap_OverrideTowingPoc',
  PingMVPChanges: 'LiveMap_PingMVPChanges',
  SelfServiceExperimentIssueBadge: 'LiveMap_SelfServiceExperiment_IssueBadge',
  SelfServiceExperimentIconWithError: 'LiveMap_SelfServiceExperiment_IconWithError'
};
